export enum ActivationEmailKeys {
  DISABLE,
  ENABLE,
  SENT_EMAIL,
}
